<div class="my-1">
  @if (field && field.invalid && field.touched && field.errors && !custom) {
    @if (field.errors['required']) {
      <div class="error-msg">
        <lib-elux-icon icon="Close.svg" size="16" color="#D21828" />
        <span [id]="id">Este campo é obrigatório.</span>
      </div>
    }

    @if (field.errors['eluxInvalidDate']) {
      <div class="error-msg">
        <lib-elux-icon [icon]="'Close.svg'" [size]="'16'" [color]="'#D21828'" />
        <span [id]="id">Data inválida.</span>
      </div>
    }

    @if (field.errors['eluxEmail']) {
      <div class="error-msg">
        <lib-elux-icon [icon]="'Close.svg'" [size]="'16'" [color]="'#D21828'" />
        <span [id]="id">E-mail inválido.</span>
      </div>
    }

    @if (field.errors['eluxPasswordMismatch']) {
      <div class="error-msg">
        <lib-elux-icon [icon]="'Close.svg'" [size]="'16'" [color]="'#D21828'" />
        <span [id]="id">As senhas precisam ser iguais.</span>
      </div>
    }

    @if (field.errors['eluxMinLength']) {
      <div class="error-msg">
        <lib-elux-icon [icon]="'Close.svg'" [size]="'16'" [color]="'#D21828'" />
        <span [id]="id">Sua nova senha deve ter pelo menos {{ field.errors['eluxMinLength'] }} caracteres.</span>
      </div>
    }

    @if (field.errors['eluxNameAlreadyExists']) {
      <div class="error-msg">
        <lib-elux-icon [icon]="'Close.svg'" [size]="'16'" [color]="'#D21828'" />
        <span [id]="id">Esse nome já está cadastrado. Experimente outro.</span>
      </div>
    }

    @if (field.errors['eluxEmailAlreadyExists']) {
      <div class="error-msg">
        <lib-elux-icon [icon]="'Close.svg'" [size]="'16'" [color]="'#D21828'" />
        <span [id]="id">Esse e-mail já está cadastrado. Experimente outro.</span>
      </div>
    }

    @if (field.errors['eluxModelAlreadyExists']) {
      <div class="error-msg">
        <lib-elux-icon [icon]="'Close.svg'" [size]="'16'" [color]="'#D21828'" />
        <span [id]="id">Este modelo já está cadastrado. Experimente outro.</span>
      </div>
    }

    @if (field.errors['eluxModelNotFound']) {
      <div class="error-msg">
        <lib-elux-icon [icon]="'Close.svg'" [size]="'16'" [color]="'#D21828'" />
        <span [id]="id">Este modelo não foi encontrado. Confira o código informado e tente novamente.</span>
      </div>
    }

    @if (field.errors['eluxTitleAlreadyExists']) {
      <div class="error-msg">
        <lib-elux-icon [icon]="'Close.svg'" [size]="'16'" [color]="'#D21828'" />
        <span [id]="id">Esse título já está cadastrado. Experimente outro.</span>
      </div>
    }

    @if (field.errors['eluxUrlAlreadyExists']) {
      <div class="error-msg">
        <lib-elux-icon [icon]="'Close.svg'" [size]="'16'" [color]="'#D21828'" />
        <span [id]="id">Essa URL já está cadastrada. Experimente outra.</span>
      </div>
    }

    @if (field.errors['eluxUrlIsInvalid']) {
      <div class="error-msg">
        <lib-elux-icon [icon]="'Close.svg'" [size]="'16'" [color]="'#D21828'" />
        <span [id]="id">Essa URL é inválida. Verifique e tente novamente.</span>
      </div>
    }

    @if (field.errors['eluxPasswordIncorrect']) {
      <div class="error-msg">
        <lib-elux-icon [icon]="'Close.svg'" [size]="'16'" [color]="'#D21828'" />
        <span [id]="id">Senha incorreta. Tente novamente.</span>
      </div>
    }
  }

  @if (custom) {
    <div class="error-msg">
      <lib-elux-icon [icon]="'Close.svg'" [size]="'16'" [color]="'#D21828'" />
      <span [id]="id">{{ customError }}</span>
    </div>
  }
</div>
